module.exports = __webpack_public_path__ + "static/media/change_05.a76554ec.jpg";